import { Button } from '@headlessui/react'
import { WithdrawButtonStatus } from '../../model'
import React from 'react'
import { DefaultLoader } from '@/shared/components/DefauilLoader/DefaultLoader'

type Props = {
  status: WithdrawButtonStatus
  isLoading?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const PayoutButton = ({
  status,
  disabled,
  onClick,
  className,
  isLoading,
  ...rest
}: Props) => {
  const baseClasses =
    'rounded-lg px-[48px] py-2 duration-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-[0.5] cursor-pointer disabled:cursor-not-allowed whitespace-nowrap'

  const variantClasses = {
    waitingProcessing:
      'bg-light-purple dark:bg-dark-purple text-primary dark:text-primary-dark hover:bg-light-purple-hover hover:dark:bg-primary-dark-hover hover:dark:text-white disabled:hover:dark:text-primary-dark disabled:bg-light-purple dark:disabled:bg-dark-purple',
    inProgress: 'bg-primary text-white hover:bg-primary-hover disabled:bg-primary',
    paidPartially:
      'bg-[var(--status-red-fill)] text-[var(--status-red-stroke)] hover:bg-[#feb1a3] dark:hover:bg-[var(--status-red-stroke)] dark:hover:text-white disabled:bg-[var(--status-red-fill)] disabled:dark:hover:bg-[var(--status-red-fill)] disabled:dark:hover:text-[var(--status-red-stroke)]',
    completed: '',
    canceled: '',
    paymentInProgress: 'bg-primary text-white hover:bg-primary-hover disabled:bg-primary',
  }[status]

  const title = {
    waitingProcessing: 'Взять в работу',
    inProgress: 'Оплатить',
    paidPartially: 'Посмотреть',
    completed: '',
    canceled: '',
    paymentInProgress: '',
  }[status]

  return (
    <Button
      className={`${baseClasses} ${variantClasses} ${className ?? ''}`}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {isLoading ? <DefaultLoader size="default" /> : title}
    </Button>
  )
}
